export default "__VITE_ASSET__C8m9R$oH__"